export default __webpack_public_path__ + "static/media/peopleIcon.b70d5ac3.png";